const f = ["theme", "default", "primary", "secondary", "success", "warning", "danger", "info", "slate", "ratings", "emerald"], E = ["black", "white", "grey"], v = ["twitter", "facebook", "tripadvisor", "google", "foursquare", "whatsapp"], R = {
  light: "#0266F1",
  dark: "#1D7FFF"
}, b = {
  light: "#617186",
  dark: "#A3AEBE"
}, L = {
  light: "#007A33",
  dark: "#2CB884"
}, F = {
  light: "#C73A02",
  dark: "#FF9014"
}, k = {
  light: "#D90048",
  dark: "#FF2E5F"
}, D = {
  light: "#7A4DE2",
  dark: "#A27AFF"
}, u = {
  light: "#DDDFE3"
}, M = {
  light: "#40DBA2",
  dark: "#40DBA2"
}, w = {
  light: "#F7C200",
  dark: "#F7C200"
}, S = {
  twitter: "#1DA1F2",
  facebook: "#1877F2",
  tripadvisor: "#34E0A1",
  google: "#D13C1F",
  foursquare: "#EC4B88",
  whatsapp: "#25D366"
};
var _ = /* @__PURE__ */ ((t) => (t[t.ALPHA = 0.06] = "ALPHA", t[t.ALPHA_THEME = 0.12] = "ALPHA_THEME", t[t.LIGHT = 0.4] = "LIGHT", t[t.DARK = 0.4] = "DARK", t[t.GREY = 0.1] = "GREY", t[t.DISABLED = 0.3] = "DISABLED", t[t.OVERLAY = 0.75] = "OVERLAY", t))(_ || {});
const a = {
  primary: R.light,
  secondary: b.light,
  blackberry: "#131825",
  ratings: w.light,
  slate: D.light,
  emerald: M.light,
  grey: u.light,
  black: "#000000",
  white: "#FFFFFF",
  overlay: "#080A10",
  // STATUS
  success: L.light,
  warning: F.light,
  danger: k.light
}, h = (t) => {
  const e = t.replace(/^#/, ""), i = parseInt(e, 16), g = i >> 16 & 255, r = i >> 8 & 255, n = i & 255;
  return g !== void 0 && r !== void 0 && n !== void 0 ? {
    red: g,
    green: r,
    blue: n
  } : {
    red: 255,
    green: 255,
    blue: 255
  };
}, o = (t, e) => {
  const i = typeof t == "string" ? h(t) : t;
  return e < 0 || e > 1 ? `rgba(${i.red}, ${i.green}, ${i.blue}, 1)` : `rgba(${i.red}, ${i.green}, ${i.blue}, ${e})`;
}, d = (t, e, i) => {
  let r = typeof t == "string" ? h(t) : t;
  r || (r = {
    red: 255,
    green: 255,
    blue: 255
  });
  const n = i === "lighten" ? 1 + e : 1 - e, A = Math.max(0, Math.min(255, Math.round(r.red * n))), C = Math.max(0, Math.min(255, Math.round(r.green * n))), O = Math.max(0, Math.min(255, Math.round(r.blue * n)));
  return `#${(1 << 24 | A << 16 | C << 8 | O).toString(16).slice(1)}`.toUpperCase();
}, l = (t, e) => d(t, e, "lighten"), s = (t, e) => d(t, e, "darken"), $ = (t) => `linear-gradient(270deg, 
        ${l(
  t,
  0.4
  /* LIGHT */
)} 0%, 
        ${t} 50%, 
        ${s(
  t,
  0.4
  /* DARK */
)} 100%)`, H = (t, e = "light", i = !1) => {
  const g = e === "light" ? l(
    t,
    0.4
    /* LIGHT */
  ) : s(
    t,
    0.4
    /* DARK */
  ), r = e === "light" ? s(
    t,
    0.4
    /* DARK */
  ) : l(
    t,
    0.4
    /* LIGHT */
  );
  return {
    alpha: o(
      g,
      i ? 0.12 : 0.06
      /* ALPHA */
    ),
    light: g,
    initial: t,
    dark: r
  };
}, G = {
  alpha: o(
    a.grey,
    0.06
    /* ALPHA */
  ),
  light: l(a.grey, 0.1),
  initial: a.grey,
  dark: s(a.grey, 0.1)
}, c = (t) => ({
  10: o(t, 0.1),
  20: o(t, 0.2),
  35: o(t, 0.35),
  50: o(t, 0.5),
  75: o(t, 0.75),
  initial: t
}), I = c(a.black), B = c(a.white);
export {
  k as DANGER_COLOR,
  M as EMERALD_COLOR,
  u as GREY_COLOR,
  a as HEX_COLORS,
  R as PRIMARY_COLOR,
  w as RATING_COLOR,
  b as SECONDARY_COLOR,
  D as SLATE_COLOR,
  S as SOCIAL_COLORS,
  L as SUCCESS_COLOR,
  _ as TransparencyEnum,
  F as WARNING_COLOR,
  d as adjustColor,
  I as blackColorObject,
  $ as convertToGradient,
  o as convertToRgba,
  s as darkenColor,
  H as generateMainColorObject,
  c as generateNeutralColorObject,
  G as greyColorObject,
  h as hexToRGB,
  l as lightenColor,
  f as mainColorVariants,
  E as neutralColorVariants,
  v as socialColorVariants,
  B as whiteColorObject
};
